import React from 'react';
const SettingsContext = React.createContext({
  settings: {},
  updateSetting: (app, name, value) => {},
});

export default SettingsContext;
